import type { CreateContractFormSchemaType } from "@/pages/shipper-contract-create/model/validation";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseDivider } from "@/shared/ui/base-divider";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { BaseTextField } from "@/shared/ui/base-text-field";
import { AccordionDetails, Stack } from "@mui/material";
import type { FreightMatching } from "@x-mile/api-contract";
import { type Control, Controller } from "react-hook-form";

export const MemoForm = ({
  control,
  deliveryProposalOfferCargo,
}: {
  deliveryProposalOfferCargo: FreightMatching.schemas.OfferCargo;
  control: Control<CreateContractFormSchemaType>;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>その他・特記事項</BaseAccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <BaseFormLabel label="その他・特記事項" sx={{ maxWidth: "376px" }}>
            <Controller
              name="memo"
              control={control}
              render={({ field, fieldState }) => (
                <BaseTextField
                  {...field}
                  variant="outlined"
                  multiline
                  fullWidth
                  rows={4}
                  error={fieldState.invalid}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </BaseFormLabel>
          <BaseDivider />
          {/* 車主提案 */}
          <BaseFormLabel
            label="その他・特記事項"
            isSuggestedByCarrier
            sx={{ maxWidth: "376px" }}
          >
            <BaseTextField
              // 車主提案項目は編集不可
              disabled
              multiline
              fullWidth
              rows={4}
              variant="outlined"
              value={deliveryProposalOfferCargo.memo}
            />
          </BaseFormLabel>
        </Stack>
      </AccordionDetails>
    </BaseAccordion>
  );
};
